module.exports = __webpack_public_path__ + "static/media/guygirl.666e7564.jpg";